import React, { Component } from 'react';
import './style.scss';
import { Tabs, Tab } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { I18n } from 'react-redux-i18n';
import * as color from '../../../../constant';
import TimeslotManager from '../TimeslotManager';
import TimeslotBinding from '../TimeslotBinding';

// Onglet « Créneaux » des réglages : deux sous-sections lourdes séparées par des
// sous-onglets — la définition des créneaux (form) et l'association des produits
// (navigateur 3 colonnes). Chaque sous-section est self-contained.
const HELP_URL =
	'https://laddition.slite.page/p/IFvpsNBO6NzB35/Gestion-de-la-carte-midi-soir';

const styles = () => ({
	indicator: { backgroundColor: color.RED_ADDITION },
	selected: { color: color.RED_ADDITION },
});

class TimeslotsTab extends Component {
	state = { tab: 0 };

	onChangeTab = (event, tab) => this.setState({ tab });

	render() {
		const { classes } = this.props;
		const { tab } = this.state;

		return (
			<div className="timeslots-tab">
				<div className="timeslots-tab-header">
					<a
						className="timeslots-tab-help"
						href={HELP_URL}
						target="_blank"
						rel="noopener noreferrer">
						<HelpOutlineIcon fontSize="small" />
						<span>{I18n.t('settings.timeslots.help_link')}</span>
					</a>
					<Tabs
						value={tab}
						onChange={this.onChangeTab}
						classes={{ indicator: classes.indicator }}
						className="timeslots-tab-nav">
						<Tab
							label={I18n.t('settings.timeslots.tab_definition')}
							classes={{ selected: classes.selected }}
						/>
						<Tab
							label={I18n.t('settings.timeslots.tab_binding')}
							classes={{ selected: classes.selected }}
						/>
					</Tabs>
				</div>

				<div className="timeslots-tab-content">
					{tab === 0 ? (
						<TimeslotManager />
					) : (
						<TimeslotBinding
							onGoToDefinition={() => this.setState({ tab: 0 })}
						/>
					)}
				</div>
			</div>
		);
	}
}

export default withStyles(styles)(TimeslotsTab);
